export default __webpack_public_path__ + "static/media/pic4.39ce4c00.jpg";